import { Injectable } from '@angular/core';
import { Router, RoutesRecognized } from '@angular/router';
import { filter } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class NavigationService {
  constructor(private readonly router: Router) {
    this.router.events
      .pipe(filter((e: any) => e instanceof RoutesRecognized))
      .subscribe((e: any) => {
        if (!e.urlAfterRedirects.includes('settings')) {
          this.setLastRouteURL(e.urlAfterRedirects, 'dispatch');
        }
      });
  }

  setLastRouteURL(url: string, urlTarget: any) {
    const lastRouteURL = '/#' + url;
    const lastRouteURLData = {
      lastRouteURL,
      urlTarget,
    };
    sessionStorage.setItem('lastRouteURL', JSON.stringify(lastRouteURLData));
  }

  getAndSetCurrentRoute() {
    const url = this.router.url;
    if (url.includes('settings')) {
      return;
    }
    this.setLastRouteURL(url, 'dispatch');
  }
}
